__turbopack_context__.v({
  "content": "PlasmicErrorSection-module__BG8LJW__content",
  "goBackBtn": "PlasmicErrorSection-module__BG8LJW__goBackBtn",
  "homePageBtn": "PlasmicErrorSection-module__BG8LJW__homePageBtn",
  "iconWrapper": "PlasmicErrorSection-module__BG8LJW__iconWrapper",
  "link": "PlasmicErrorSection-module__BG8LJW__link",
  "main": "PlasmicErrorSection-module__BG8LJW__main",
  "nav": "PlasmicErrorSection-module__BG8LJW__nav",
  "text__fRbnz": "PlasmicErrorSection-module__BG8LJW__text__fRbnz",
  "text__jb0XZ": "PlasmicErrorSection-module__BG8LJW__text__jb0XZ",
  "text__mqh": "PlasmicErrorSection-module__BG8LJW__text__mqh",
  "text__mvNvr": "PlasmicErrorSection-module__BG8LJW__text__mvNvr",
  "text__nd3Xf": "PlasmicErrorSection-module__BG8LJW__text__nd3Xf",
  "text__vz5Ro": "PlasmicErrorSection-module__BG8LJW__text__vz5Ro",
  "title": "PlasmicErrorSection-module__BG8LJW__title",
  "wrapper": "PlasmicErrorSection-module__BG8LJW__wrapper",
});
